import { Injectable } from '@angular/core';
import { RidangoReduxAction, CardBalance } from '@ridango/core';


@Injectable()
export class CardInfoActions {
    static SET_CARD_NUMBER = '[CardInfo]: Set Card Number';
    static SET_CARD_BALANCE = '[CardInfo]: Set Card Balance';
    static SET_CARD_TICKETS = '[CardInfo]: Set Card Tickets';

    static SET_FROM_DATE = '[CardInfo]: Set From Date';
    static SET_TO_DATE = '[CardInfo]: Set To Date';
    static SET_CARD_HISTORY = '[CardInfo]: Set Card History';
    static SET_CARD_INFO_LOADING = '[CardInfo]: Set Card History Loading';
    setCardNumber ( payload ): RidangoReduxAction {
        return {
            type: CardInfoActions.SET_CARD_NUMBER,
            payload: payload
        };
    }
    setCardBalance ( payload: CardBalance ): RidangoReduxAction {
        return {
            type: CardInfoActions.SET_CARD_BALANCE,
            payload: payload
        };
    }
    setCardTickets ( payload ): RidangoReduxAction {
        return {
            type: CardInfoActions.SET_CARD_TICKETS,
            payload: payload
        };
    }

    setFromDate ( date ): RidangoReduxAction {
        return {
            type: CardInfoActions.SET_FROM_DATE,
            payload: date
        };
    }
    setToDate ( date ): RidangoReduxAction {
        return {
            type: CardInfoActions.SET_TO_DATE,
            payload: date
        };
    }

    setHistory ( history ): RidangoReduxAction {
        return {
            type: CardInfoActions.SET_CARD_HISTORY,
            payload: history
        };
    }

    setLoading ( loading ): RidangoReduxAction {
        return {
            type: CardInfoActions.SET_CARD_INFO_LOADING,
            payload: loading
        };
    }

}
